
<ng-template #coBorrowersAdressHistory>
  <div class="row mb-10">
    @for (coBorrower of coBorrowers; track coBorrower.borrowerId; let i = $index) {
      <div class="col-md-12 fv-row mb-5">
        <div class="card card-flush shadow-sm">
          <div class="card-header">
            <h3 class="card-title">{{coBorrower.firstName + " " + coBorrower.lastName}}</h3>
          </div>
          <div class="card-body py-2">
            <borrower-address-history [borrower]="coBorrower" [currentAddressLabel]="'Current Address'"></borrower-address-history>
          </div>
        </div>
      </div>
    }
  </div>
</ng-template>

<wizard-step-template [stepMainTemplate]="coBorrowersAdressHistory" [step]="step" [stepComponent]="this"></wizard-step-template>
